import {Component, ReactNode} from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import sentry from '@/shared/utils/sentry';
import ErrorView from './ErrorView';

type State = {
  error: null | Error;
  redirectToLogout: boolean;
};

type Props = RouteComponentProps & {
  children: ReactNode;
};

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {error: null, redirectToLogout: false};
  }

  static getDerivedStateFromError(error: Error | null) {
    return {error, redirectToLogout: false};
  }

  componentDidCatch(error: Error): void {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: {
          url: `${document.location.origin}/error`,
          title: 'Error page'
        }
      });
    }
    sentry.captureException(error);
  }

  render(): ReactNode {
    if (this.state.error) {
      return <ErrorView />;
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
